export default function pecepComingSoon() {
    const header = document.querySelector("#header")
    header.style.display = 'none'
    console.log('coming-soon', header);
}
